import type {
  ConveyedPersonAction,
  PersonInvolvementKind,
} from "../types/involvement.js";
import type { CustomerRole } from "../types/thalamos.js";
import { personActionsConveyedByInvolvementKind } from "./personActionsConveyedByInvolvementKind.js";
import { personActionsPermittedByRoleOrNone } from "./personActionsPermittedByRoleOrNone.js";
import { roleOrNone } from "./roleOrNone.js";

/** What an involvement of this kind conveys to a party acting in this role; `null` is a guest. */
export const personActionsFromInvolvementKindInRole = (
  kind: PersonInvolvementKind,
  role: CustomerRole | null,
): ConveyedPersonAction[] => {
  const permitted = new Set(
    personActionsPermittedByRoleOrNone[roleOrNone(role)],
  );

  return personActionsConveyedByInvolvementKind[kind].filter((action) =>
    permitted.has(action),
  );
};
